import React from "react";
import PropTypes from "prop-types";

class Pagination extends React.PureComponent {

    static defaultProps = {
        items: []
    };

    static propTypes = {
        limit: PropTypes.number.isRequired,
        items: PropTypes.array.isRequired,
        renderItem: PropTypes.func.isRequired,
        renderPrevPageButton: PropTypes.func.isRequired,
        renderNextPageButton: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = this.parseStateFromProps(props);

        this.handleNextPage = this.handleNextPage.bind(this);
        this.handlePrevPage = this.handlePrevPage.bind(this);
    }


    render() {
        let {renderNextPageButton, renderPrevPageButton, renderItem} = this.props;

        if (!this.props.items.length) {
            return null;
        }

        return <div>
            {renderPrevPageButton(this.hasPrevPage(), this.handlePrevPage)}
            {this.getItems().map(item => renderItem(item))}
            {renderNextPageButton(this.hasNextPage(), this.handleNextPage)}
        </div>;
    }

    parseStateFromProps(props) {

        const listLength = props.items.length;
        return {
            pages: Math.ceil(listLength / props.limit),
            currentPage: 1,
            limit: props.limit
        };
    }

    componentWillUpdate(nextProps) {
        if (nextProps.items !== this.props.items) {
            this.setState(this.parseStateFromProps(nextProps))
        }
    }

    getItems() {
        let {currentPage, limit} = this.state;
        let from = (currentPage - 1) * limit;
        let to = currentPage * limit;
        return this.props.items.slice(from, to);
    }

    handlePrevPage() {
        this.setState(
            prevState => ({currentPage: Math.max(prevState.currentPage - 1, 1)})
        );
    }

    handleNextPage() {
        this.setState(
            prevState => {
                let newPage = prevState.currentPage + 1;
                if (newPage > prevState.pages) {
                    return null
                }

                return {currentPage: newPage}
            }
        );
    }

    hasPrevPage() {
        return this.state.currentPage !== 1
    }

    hasNextPage() {
        return (this.state.currentPage < this.state.pages)
    }

}

export default Pagination